import getOptionBracketsReducer from './get-option-brackets-slice.ts'
import getTickerCurrentDataSlice from './get-ticker-current-data-slice.ts'

export const PagesReducers = {
    getOptionBracketsState: getOptionBracketsReducer,
    getTickerCurrentDataState: getTickerCurrentDataSlice
}